export var IDENTIFIER_VIDEO_PLAYER = 'video-player';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS = 'video-player-actions';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS_PLAY = 'video-player-actions-play';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS_SPEED = 'video-player-actions-speed';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS_FULLSCREEN = 'video-player-actions-fullscreen';
export var IDENTIFIER_VIDEO_PLAYER_TIME_VALIDATION = 'video-player-time-validation';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS_ZOOM_IN = 'video-player-actions-zoom-in';
export var IDENTIFIER_VIDEO_PLAYER_ACTIONS_ZOOM_OUT = 'video-player-actions-zoom-out';
export var VIDEO_ZOOM_STEP = 1;
export var VIDEO_ZOOM_INITIAL_POSITION = { x: 0, y: 0 };
